import { BodyText, DetailText, Flex } from '@utilitywarehouse/hearth-react';
import { ReactNode } from 'react';

import { ServiceTile, getServiceTileId } from './ServiceTile';
import { BreakdownButtonConfig } from './types';

interface EnergyTileProps {
  breakdown?: BreakdownButtonConfig;
  description: ReactNode;
  discountedPrice?: string;
  isSelected: boolean;
  price: string;
  serviceName: string;
  testId?: string;
  value: string;
}

interface PriceProps {
  discountedPrice?: string;
  price: string;
  serviceName: string;
}

const Price = ({ discountedPrice, price, serviceName }: PriceProps) => {
  const priceId = getServiceTileId(serviceName, 'price');

  return (
    <Flex wrap="wrap" alignItems="baseline">
      <Flex alignItems="baseline" spacing="sm" marginRight="100">
        {discountedPrice && (
          <DetailText className="service-tile__discounted-price" size="sm">
            {discountedPrice}
          </DetailText>
        )}
        <DetailText data-testid="service-tile-price" id={priceId} size="3xl">
          {price}
        </DetailText>{' '}
      </Flex>
      <BodyText size="sm">monthly estimate</BodyText>
    </Flex>
  );
};

const EnergyTile = ({
  breakdown,
  description,
  discountedPrice,
  isSelected,
  price,
  serviceName,
  testId,
  value,
}: EnergyTileProps) => (
  <ServiceTile
    buttonText="Tariff"
    description={
      <BodyText size="md" color="secondary">
        {description}
      </BodyText>
    }
    isSelected={isSelected}
    serviceName={serviceName}
    testId={testId}
    value={value}
    breakdown={breakdown}
  >
    <Price
      discountedPrice={discountedPrice}
      price={price}
      serviceName={serviceName}
    />
  </ServiceTile>
);

export { EnergyTile };
export type { EnergyTileProps };
